module.exports = __webpack_public_path__ + "static/MT_Process-01.12ade7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-01.png
// module id = 1498
// module chunks = 214286880276331